import React, { useCallback, useEffect, useState } from "react";
import { getQualityControls } from "../../api";
import { ShieldCheck, Plus, ChevronLeft } from "lucide-react";
import QualityForm from "../quality/QualityForm";
import QualityDetail, { LevelBadge, fmtDate } from "../quality/QualityDetail";
import ActionsList from "../quality/ActionsList";
import { useToast } from "../../hooks/use-toast";
import { log } from "../../lib/log";

/* Mobile « Qualité » tab (majors only): on-site quality controls with GPS, photos and client visa. */
const QualityTab = ({ login }) => {
  const [items, setItems] = useState([]);
  const [creating, setCreating] = useState(false);
  const [selected, setSelected] = useState(null);
  const [view, setView] = useState("controles");
  const { toast } = useToast();
  const load = useCallback(() => getQualityControls({ login, limit: 50 }).then((r) => setItems(r.data.items)).catch(log.error), [login]);
  useEffect(() => { load(); }, [load]);

  if (creating) return (
    <div data-testid="collab-quality-form">
      <button onClick={() => setCreating(false)} className="text-sm text-neutral-600 flex items-center gap-1 mb-3" data-testid="collab-quality-back"><ChevronLeft size={16} /> Retour</button>
      <h2 className="font-heading font-bold text-lg text-neutral-900 mb-3">Contrôle qualité sur site</h2>
      <QualityForm requireGps onCancel={() => setCreating(false)} onDone={(qc) => { setCreating(false); load(); toast({ title: `Contrôle validé — ${qc.score_pct} %`, description: qc.report_sent_at ? "Rapport envoyé au client." : undefined }); }} />
    </div>
  );

  return (
    <div data-testid="collab-quality">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading font-bold text-lg text-neutral-900 flex items-center gap-2"><ShieldCheck size={18} className="text-brand" /> Mes contrôles qualité</h2>
        <button onClick={() => setCreating(true)} className="bg-brand text-white text-sm font-semibold px-3 py-2 rounded-md flex items-center gap-1.5" data-testid="collab-quality-new"><Plus size={15} /> Nouveau</button>
      </div>
      <div className="flex rounded-md border border-neutral-300 overflow-hidden text-sm mb-4 w-fit" data-testid="collab-quality-switch">
        <button onClick={() => setView("controles")} className={`px-3 py-1.5 font-semibold ${view === "controles" ? "bg-brand text-white" : "bg-white text-neutral-600"}`} data-testid="collab-quality-view-controles">Mes contrôles</button>
        <button onClick={() => setView("actions")} className={`px-3 py-1.5 font-semibold ${view === "actions" ? "bg-brand text-white" : "bg-white text-neutral-600"}`} data-testid="collab-quality-view-actions">Actions à clôturer</button>
      </div>
      {view === "actions" ? <ActionsList compact /> : items.length === 0 ? <p className="text-sm text-neutral-500 text-center py-10">Aucun contrôle réalisé pour le moment.</p> : (
        <div className="space-y-2">
          {items.map((c) => (
            <button key={c.id} onClick={() => setSelected(c)} className="w-full text-left bg-white border border-neutral-200 rounded-xl p-3 flex items-center gap-3" data-testid={`collab-quality-row-${c.id}`}>
              <div className="min-w-0 flex-1"><p className="font-semibold text-sm text-neutral-900 truncate">{c.client_nom}</p><p className="text-xs text-neutral-500">{fmtDate(c.date)}{c.report_sent_at ? " · rapport envoyé" : ""}</p></div>
              <LevelBadge qc={c} />
            </button>
          ))}
        </div>
      )}
      {selected && <QualityDetail qc={selected} onClose={() => setSelected(null)} onChanged={load} />}
    </div>
  );
};

export default QualityTab;
